import { getDisplayCategories } from 'academy-common-lib/utils/categories';
// @ts-expect-error Could not find a declaration file for module
import InfoButtonModalOpener from '../../../containers/AcademyToSoftware/InfoButtonModalOpener';
import { useLearningContentCardTo } from '../cardsHooks';
// @ts-expect-error Could not find a declaration file for module
import useFilterParams from '../../../hooks/useFilterParams';
import UsageTracker from '../../../utils/UsageTracker';
import TrackDeprecatedDescription from '../../../components/TrackCard/TrackDeprecatedDescription';
import enviro from 'enviro';
import LearningContentCardAwardLink from './LearningContentCardAwardLink';
import CardMenuIcon from '../../cardMenu/components/CardMenuIcon';
import ACContentCard from 'academy-common-lib/components/card/ACContentCard';
import ACThumbnailOverlay from 'academy-common-lib/components/card/ACThumbnailOverlay';
import { LearningContentTimeReadout } from './LearningContentTimeReadout';
import { useCallback } from 'react';
import styled from 'styled-components';
import { LearningContentTitle } from './LearningContentThumbnail';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailTypeMap = {
  TRACK: 'COURSE',
  COURSE: 'COURSE',
  LESSON: 'LESSON',
  PLAYLIST: 'PLAYLIST',
  LEARNING_PATH: 'HUBSPOT_PLAYLIST',
  SHORT_FORM_CONTENT: 'VIDEO'
};
const HeaderIcons = styled.div.withConfig({
  displayName: "FullLearningContentCard__HeaderIcons",
  componentId: "mouvc1-0"
})(["position:absolute;top:14px;right:12px;z-index:2;"]);
const useHasInfoButton = ({
  id,
  type
}) => type === 'TRACK' && enviro.isQa() ? [11979, 220].includes(id) : [5, 12, 97, 2274639, 2202162].includes(id);
const InfoButton = ({
  displayCategories
}) => {
  if (!(displayCategories !== null && displayCategories !== void 0 && displayCategories.length)) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: displayCategories.map(label =>
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(InfoButtonModalOpener, {
      className: "m-left-2",
      selectedSoftware: label.toLowerCase()
    }, label))
  });
};
export const FullLearningContentCard = ({
  item,
  onItemClick,
  use,
  showOverview,
  body,
  footer,
  isGhost,
  position,
  overviewType,
  playlistId,
  thumbnailHeader,
  renderMenu = menu => menu,
  extraTrackingInfo,
  className,
  isFlushOnMobile = true,
  alwaysShowMenu,
  isNotFilterable
}) => {
  const {
    id,
    type,
    language,
    name,
    progress,
    previewThumbnailRectangleUrl,
    description
  } = item;
  const {
    isDeprecated,
    certification,
    deprecationWarningDate,
    deprecationMessage,
    deprecationCta,
    subCategories,
    duration
  } = item;
  const displayCategories = subCategories ? getDisplayCategories(subCategories) : [];
  const completed = (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED';
  const {
    itemsCount = 0
  } = item;
  const {
    lessonType
  } = item;
  const {
    completedItemsCount = 0
  } = progress || {};
  const remainingItems = itemsCount - completedItemsCount;
  const hasInfoButton = useHasInfoButton(item);
  const to = useLearningContentCardTo({
    item,
    overviewType,
    playlistId,
    showOverview
  });
  const filterParams = useFilterParams();
  const handleOnClick = useCallback(() => {
    UsageTracker.track('interaction', Object.assign({
      action: 'content-card-click',
      contentId: id,
      contentType: type,
      appearsIn: overviewType,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default',
      isInProgress: (progress === null || progress === void 0 ? void 0 : progress.status) === 'IN_PROGRESS',
      isCertification: certification,
      playlistId
    }, extraTrackingInfo));
    if (onItemClick) onItemClick(item);
  }, [id, type, overviewType, position, name, filterParams, progress === null || progress === void 0 ? void 0 : progress.status, certification, playlistId, extraTrackingInfo, onItemClick, item]);
  const isInDeprecationWarningPeriod = !!deprecationWarningDate && deprecationWarningDate < new Date().getTime() && !isDeprecated;
  return /*#__PURE__*/_jsx(ACContentCard, {
    className: className,
    "data-test-id": "card",
    "data-test-is-certification": Boolean(certification),
    "data-test-is-unfilterable": Boolean(isNotFilterable),
    "data-test-meta": id,
    "data-test-type": type,
    description: isDeprecated || isInDeprecationWarningPeriod ? /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(TrackDeprecatedDescription, {
        cta: deprecationCta,
        message: deprecationMessage,
        trackId: id
      })
    }) : body || description,
    disabled: isDeprecated || isGhost,
    isFlushOnMobile: isFlushOnMobile,
    name: name,
    onClick: handleOnClick,
    thumbnailOverlay: /*#__PURE__*/_jsxs(ACThumbnailOverlay, {
      categories: displayCategories,
      completed: completed,
      contentType: certification ? 'CERTIFICATION' : ThumbnailTypeMap[type],
      contentTypeName: /*#__PURE__*/_jsx(LearningContentTitle, {
        certification: certification,
        lessonTypes: lessonType,
        type: type
      }),
      duration: duration || itemsCount,
      footer: footer || /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LearningContentTimeReadout, {
          item: item,
          use: use
        }), type === 'TRACK' && /*#__PURE__*/_jsx(LearningContentCardAwardLink, {
          trackId: id,
          use: use
        })]
      }),
      remainingTime: (progress === null || progress === void 0 ? void 0 : progress.remainingDuration) || remainingItems,
      children: [thumbnailHeader, /*#__PURE__*/_jsx(HeaderIcons, {
        children: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
          isDisabled: !alwaysShowMenu && isDeprecated,
          item: {
            id,
            type: type,
            language: language
          },
          use: "on-dark"
        }))
      })]
    }),
    thumbnailSrc: previewThumbnailRectangleUrl,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [name, hasInfoButton && /*#__PURE__*/_jsx(InfoButton, {
        displayCategories: displayCategories
      })]
    }),
    to: isDeprecated ? null : to,
    use: use
  });
};
export default FullLearningContentCard;